import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../apiConfig';
import VehicleMaintenance from '../../components/fleet/VehicleMaintenance';
import bigTaxiDriverLogo from '../../assets/big-taxi-driver-logo.png';

const publicApi = axios.create({ baseURL: API_BASE_URL, timeout: 30000 });

export default function DriverMaintenance() {
  const [vehicles, setVehicles] = useState([]);
  const [error, setError] = useState('');
  useEffect(() => {
    publicApi.get('/driver/public-vehicle-maintenance/vehicles').then(({ data }) => setVehicles(data))
      .catch(() => setError('車両情報を取得できませんでした。通信状況を確認してページを再読み込みしてください。'));
  }, []);
  return <main className="fleet-premium fleet-maintenance-public">
    <div className="fleet-maintenance-public-inner">
      <header className="fleet-maintenance-brand">
        <img src={bigTaxiDriverLogo} alt="Big Taxi" width="64" height="64" />
        <div><p>BIG TAXI</p><span>車両整備管理</span></div>
      </header>
      {error && <p role="alert" className="text-red-400">{error}</p>}
      <VehicleMaintenance vehicles={vehicles} canEdit publicMode client={publicApi} endpoint="/driver/public-vehicle-maintenance" onSaved={() => {}} />
    </div>
  </main>;
}
